(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQaccord"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function animatePanel(details, panel) {
      var isOpen = details.hasAttribute('open');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      if (isOpen) {
        panel.style.height = '0px';
        requestAnimationFrame(function () {
          var target = panel.scrollHeight;
          panel.style.height = target + 'px';
        });

        panel.addEventListener('transitionend', function onEnd(e) {
          if (e.propertyName !== 'height') return;
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', onEnd);
        });
      } else {
        var current = panel.scrollHeight;
        panel.style.height = current + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            panel.style.height = '0px';
          });
        });
      }
    }

    function initAccordion(section) {
      var items = Array.prototype.slice.call(
        section.querySelectorAll('.faq-accordion__item')
      );

      items.forEach(function (details) {
        var summary = details.querySelector('.faq-accordion__question');
        var panel = details.querySelector('[data-faq-panel]');
        if (!summary || !panel) return;

        if (details.hasAttribute('open')) {
          panel.style.height = 'auto';
        } else {
          panel.style.height = '0px';
        }

        summary.addEventListener('click', function (event) {
          event.preventDefault();

          var willOpen = !details.hasAttribute('open');

          if (willOpen) {
            details.setAttribute('open', '');
          }

          animatePanel(details, panel);

          if (!willOpen) {
            window.setTimeout(function () {
              details.removeAttribute('open');
            }, 220);
          }
        });
      });
    }

    function init() {
      document.querySelectorAll('.faq-accordion').forEach(initAccordion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.faq-accordion');
      if (section) initAccordion(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SaunaCall"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR = '[data-sauna-roi-app]';
  var JSPDF_CDN_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';

  var initialised = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var initialisedFallback = [];
  var jsPdfLoadPromise = null;

  var ctaInitialised = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var ctaInitialisedFallback = [];

  function isInitialised(el) {
    if (initialised) return initialised.has(el);
    return initialisedFallback.indexOf(el) !== -1;
  }

  function markInitialised(el) {
    if (initialised) {
      initialised.add(el);
    } else {
      initialisedFallback.push(el);
    }
  }

  function isCtaInitialised(el) {
    if (ctaInitialised) return ctaInitialised.has(el);
    return ctaInitialisedFallback.indexOf(el) !== -1;
  }

  function markCtaInitialised(el) {
    if (ctaInitialised) {
      ctaInitialised.add(el);
    } else {
      ctaInitialisedFallback.push(el);
    }
  }

  function formatCurrency(amount, symbol) {
    if (!isFinite(amount)) amount = 0;
    var rounded = Math.round(amount);
    var negative = rounded < 0;
    var abs = Math.abs(rounded);
    var withCommas = abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (negative ? '-' : '') + symbol + withCommas;
  }

  function formatNumber(value) {
    if (!isFinite(value)) return '0';
    var rounded = Math.round(value * 10) / 10;
    return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatPercent(value) {
    if (!isFinite(value)) return '0%';
    var rounded = Math.round(value * 10) / 10;
    return rounded + '%';
  }

  function fillTemplate(template, tokens) {
    var result = template || '';
    Object.keys(tokens).forEach(function (key) {
      result = result.split('{' + key + '}').join(tokens[key]);
    });
    return result;
  }

  // Loads jsPDF from cdnjs the first time it's needed (only when someone
  // clicks "View results as PDF"), and reuses the same load promise for
  // every calculator instance on the page.
  function loadJsPDF() {
    if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
    if (jsPdfLoadPromise) return jsPdfLoadPromise;
    jsPdfLoadPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = JSPDF_CDN_URL;
      script.async = true;
      script.onload = function () {
        if (window.jspdf && window.jspdf.jsPDF) {
          resolve(window.jspdf.jsPDF);
        } else {
          reject(new Error('jsPDF loaded but did not initialise as expected.'));
        }
      };
      script.onerror = function () {
        jsPdfLoadPromise = null;
        reject(new Error('Could not load jsPDF from cdnjs.'));
      };
      document.head.appendChild(script);
    });
    return jsPdfLoadPromise;
  }

  // Loads the merchant's logo/insignia (if one is set) and converts it to
  // a base64 PNG via canvas, since jsPDF's addImage needs base64 data
  // rather than an image URL. Resolves to null on any failure (missing
  // image, CORS-tainted canvas, etc.) so a logo issue never blocks the
  // PDF itself - it's just omitted.
  function loadLogoImage(url) {
    if (!url) return Promise.resolve(null);
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve({
            dataUrl: canvas.toDataURL('image/png'),
            width: img.naturalWidth,
            height: img.naturalHeight
          });
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = function () {
        resolve(null);
      };
      img.src = url;
    });
  }

  // Scenario math (recurring monthly-rental model, no upfront investment):
  //   monthly revenue = price per rental x rentals/month (scenario-scaled, capped)
  //   monthly cost     = fixed monthly rental price (does NOT scale with rentals)
  //   monthly profit   = monthly revenue - monthly cost
  //   annual figures    = monthly figures x operating months
  //   ROI %             = annual profit / annual cost x 100
  function computeScenario(p) {
    var rentalsPerMonth = Math.min(p.customerRentals * p.multiplier, p.maxRentals);
    var monthlyRevenue = p.price * rentalsPerMonth;
    var monthlyCost = p.monthlyCost;
    var monthlyProfit = monthlyRevenue - monthlyCost;
    var annualRevenue = monthlyRevenue * p.months;
    var annualCost = monthlyCost * p.months;
    var annualProfit = annualRevenue - annualCost;
    var roiPercent = annualCost > 0 ? (annualProfit / annualCost) * 100 : 0;
    var threeYearProfit = annualProfit * 3;
    var threeYearCost = annualCost * 3;
    var threeYearRoi = threeYearCost > 0 ? (threeYearProfit / threeYearCost) * 100 : 0;

    return {
      rentalsPerMonth: rentalsPerMonth,
      monthlyRevenue: monthlyRevenue,
      monthlyCost: monthlyCost,
      monthlyProfit: monthlyProfit,
      annualRevenue: annualRevenue,
      annualCost: annualCost,
      annualProfit: annualProfit,
      roiPercent: roiPercent,
      threeYearProfit: threeYearProfit,
      threeYearRoi: threeYearRoi
    };
  }

  function setOut(card, key, text) {
    var el = card.querySelector('[data-out="' + key + '"]');
    if (el) el.textContent = text;
  }

  // WebKit/Blink have no ::-webkit-slider-progress pseudo-element, so the
  // filled portion of the track is painted by setting a gradient directly
  // on the input. The colors themselves stay as CSS var() references, so
  // they still resolve to whatever the merchant set (or the accent
  // fallback) at paint time -- no color values are computed in JS.
  function paintSliderFill(slider) {
    var min = parseFloat(slider.min) || 0;
    var max = parseFloat(slider.max) || 100;
    var value = parseFloat(slider.value) || 0;
    var percent = max > min ? ((value - min) / (max - min)) * 100 : 0;
    percent = Math.max(0, Math.min(100, percent));

    var fill = 'var(--sauna-roi-slider-fill, var(--sauna-roi-accent))';
    var track = 'var(--sauna-roi-slider-track, rgba(var(--color-foreground, 26, 26, 26), 0.14))';

    slider.style.background =
      'linear-gradient(to right, ' + fill + ' 0%, ' + fill + ' ' + percent + '%, ' +
      track + ' ' + percent + '%, ' + track + ' 100%)';
  }

  // Makes the CTA button behave as a true same-page anchor: if its href
  // points at an element that actually exists on the current page, the
  // click is intercepted, the browser is stopped from doing a real
  // navigation/reload, and the page is smooth-scrolled to the target
  // instead. If the href points somewhere else entirely (a different
  // page, a mailto:, an external site, or a hash that doesn't match any
  // element on this page), the click is left completely alone so the
  // link still works normally.
  function initCtaAnchor(link) {
    if (!link || isCtaInitialised(link)) return;

    link.addEventListener('click', function (event) {
      // A merchant-configured "open in new tab" CTA is meant to leave the
      // page, so never intercept that case.
      if (link.target === '_blank') return;

      var href = link.getAttribute('href') || '';
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;

      var hash = href.slice(hashIndex + 1);
      if (!hash) return;

      // Deliberately do NOT try to compare href/origin/path against
      // window.location here: Shopify's URL picker can resolve the same
      // in-page anchor to several different absolute-URL forms (custom
      // domain vs *.myshopify.com, trailing slash, protocol), and any
      // string comparison risks a false negative that lets a real
      // navigation slip through - which is exactly what caused the
      // reload-then-jump behaviour. Checking for the element directly is
      // both simpler and airtight: if it exists anywhere in the current
      // document, we are unambiguously already on the right page.
      var target = document.getElementById(hash);
      if (!target) return; // not on this page - let the browser navigate normally

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', '#' + hash);
      } else {
        window.location.hash = hash;
      }
    });

    markCtaInitialised(link);
  }

  function initSection(root) {
    if (!root || isInitialised(root)) return;

    var currency = root.getAttribute('data-currency-symbol') || '\u00A3';
    var conservativeMult = (parseFloat(root.getAttribute('data-conservative-multiplier')) || 0) / 100;
    var expectedMult = (parseFloat(root.getAttribute('data-expected-multiplier')) || 0) / 100;
    var strongMult = (parseFloat(root.getAttribute('data-strong-multiplier')) || 0) / 100;
    var maxRentals = parseFloat(root.getAttribute('data-max-rentals')) || 0;
    var showThreeYear = root.getAttribute('data-show-three-year') === 'true';

    var breakevenTemplate = root.getAttribute('data-breakeven-template') || '';
    var breakevenZeroPrice = root.getAttribute('data-breakeven-zero-price') || '';
    var breakevenZeroCost = root.getAttribute('data-breakeven-zero-cost') || '';

    var pdfTitle = root.getAttribute('data-pdf-title') || 'ROI Estimate';
    var pdfGeneratingLabel = root.getAttribute('data-pdf-generating-label') || 'Preparing your PDF...';
    var pdfErrorLabel = root.getAttribute('data-pdf-error-label') || "Sorry, we couldn't create the PDF.";
    var pdfLogoUrl = root.getAttribute('data-pdf-logo') || '';
    var disclaimerText = root.getAttribute('data-disclaimer-text') || '';

    var emailSubject = root.getAttribute('data-email-subject') || 'My sauna rental ROI estimate';
    var emailIntroText = root.getAttribute('data-email-intro-text') || '';
    var emailOutroText = root.getAttribute('data-email-outro-text') || '';

    var priceSlider = root.querySelector('[data-price-slider]');
    var rentalsSlider = root.querySelector('[data-rentals-slider]');
    var monthsSlider = root.querySelector('[data-months-slider]');
    var monthlyCostSlider = root.querySelector('[data-monthly-cost-slider]');

    if (!priceSlider || !rentalsSlider || !monthsSlider || !monthlyCostSlider) return;

    var priceOutput = root.querySelector('[data-price-output]');
    var rentalsOutput = root.querySelector('[data-rentals-output]');
    var monthsOutput = root.querySelector('[data-months-output]');
    var monthlyCostOutput = root.querySelector('[data-monthly-cost-output]');

    var priceNumber = root.querySelector('[data-price-number]');
    var rentalsNumber = root.querySelector('[data-rentals-number]');
    var monthsNumber = root.querySelector('[data-months-number]');
    var monthlyCostNumber = root.querySelector('[data-monthly-cost-number]');

    var breakevenNote = root.querySelector('[data-sauna-roi-breakeven]');
    var pdfButton = root.querySelector('[data-sauna-roi-pdf]');
    var emailButton = root.querySelector('[data-sauna-roi-email]');

    var cards = {
      conservative: root.querySelector('[data-scenario="conservative"]'),
      expected: root.querySelector('[data-scenario="expected"]'),
      strong: root.querySelector('[data-scenario="strong"]')
    };

    var threeYearRows = root.querySelectorAll('[data-three-year-row]');
    var i;
    for (i = 0; i < threeYearRows.length; i++) {
      threeYearRows[i].hidden = !showThreeYear;
    }

    var rafId = null;

    function scheduleUpdate() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        update();
      });
    }

    function syncField(slider, numberInput, output, prefix) {
      var value = slider.value;
      if (numberInput && numberInput !== document.activeElement) {
        numberInput.value = value;
      }
      if (output) {
        output.textContent = (prefix || '') + formatNumber(parseFloat(value));
      }
      paintSliderFill(slider);
    }

    function clamp(input, min, max) {
      var value = parseFloat(input.value);
      if (isNaN(value)) return min;
      if (value < min) return min;
      if (value > max) return max;
      return value;
    }

    function updateBreakeven(price, monthlyCost) {
      if (!breakevenNote) return;
      if (price <= 0) {
        breakevenNote.textContent = breakevenZeroPrice;
        return;
      }
      if (monthlyCost <= 0) {
        breakevenNote.textContent = breakevenZeroCost;
        return;
      }
      var rentalsNeeded = Math.ceil(monthlyCost / price);
      breakevenNote.textContent = fillTemplate(breakevenTemplate, {
        rentals: formatNumber(rentalsNeeded),
        rental_word: rentalsNeeded === 1 ? 'rental' : 'rentals',
        price: formatCurrency(price, currency),
        cost: formatCurrency(monthlyCost, currency)
      });
    }

    function update() {
      var price = parseFloat(priceSlider.value) || 0;
      var rentals = parseFloat(rentalsSlider.value) || 0;
      var months = parseFloat(monthsSlider.value) || 0;
      var monthlyCost = parseFloat(monthlyCostSlider.value) || 0;

      syncField(priceSlider, priceNumber, priceOutput, currency);
      syncField(rentalsSlider, rentalsNumber, rentalsOutput, '');
      syncField(monthsSlider, monthsNumber, monthsOutput, '');
      syncField(monthlyCostSlider, monthlyCostNumber, monthlyCostOutput, currency);

      updateBreakeven(price, monthlyCost);

      var scenarioParams = {
        conservative: conservativeMult,
        expected: expectedMult,
        strong: strongMult
      };

      Object.keys(scenarioParams).forEach(function (key) {
        var card = cards[key];
        if (!card) return;

        var s = computeScenario({
          price: price,
          customerRentals: rentals,
          months: months,
          monthlyCost: monthlyCost,
          multiplier: scenarioParams[key],
          maxRentals: maxRentals
        });

        setOut(card, 'rentals', formatNumber(s.rentalsPerMonth) + ' / month');
        setOut(card, 'monthly-revenue', formatCurrency(s.monthlyRevenue, currency));
        setOut(card, 'monthly-cost', formatCurrency(s.monthlyCost, currency));
        setOut(card, 'monthly-profit', formatCurrency(s.monthlyProfit, currency));
        setOut(card, 'annual-revenue', formatCurrency(s.annualRevenue, currency));
        setOut(card, 'annual-cost', formatCurrency(s.annualCost, currency));
        setOut(card, 'annual-profit', formatCurrency(s.annualProfit, currency));
        setOut(card, 'roi', formatPercent(s.roiPercent));

        if (showThreeYear) {
          setOut(card, 'three-year-profit', formatCurrency(s.threeYearProfit, currency));
          setOut(card, 'three-year-roi', formatPercent(s.threeYearRoi));
        }
      });
    }

    // Reads whatever is currently rendered on screen, so the PDF and
    // email always match the merchant's custom labels and the visitor's
    // current slider values - no duplicate state to keep in sync.
    function collectInputsSummary() {
      var lines = [];
      var fields = root.querySelectorAll('.sauna-roi__field');
      fields.forEach(function (field) {
        var label = field.querySelector('.sauna-roi__field-head label');
        var output = field.querySelector('.sauna-roi__field-value output');
        if (label && output) {
          lines.push(label.textContent.trim() + ': ' + output.textContent.trim());
        }
      });
      return lines;
    }

    function collectScenarioCards() {
      var cardEls = root.querySelectorAll('.sauna-roi__card');
      var result = [];
      cardEls.forEach(function (cardEl) {
        var tagEl = cardEl.querySelector('.sauna-roi__card-tag');
        var rows = [];
        var rowEls = cardEl.querySelectorAll('.sauna-roi__card-row');
        rowEls.forEach(function (rowEl) {
          if (rowEl.hidden) return;
          var dt = rowEl.querySelector('dt');
          var dd = rowEl.querySelector('dd');
          if (dt && dd) {
            rows.push({ label: dt.textContent.trim(), value: dd.textContent.trim() });
          }
        });
        result.push({ name: tagEl ? tagEl.textContent.trim() : '', rows: rows });
      });
      return result;
    }

    // logo is either null (no logo set / failed to load) or
    // { dataUrl, width, height } from loadLogoImage().
    function buildPdf(JsPDFCtor, logo) {
      var doc = new JsPDFCtor({ unit: 'pt', format: 'a4' });
      var margin = 40;
      var pageWidth = doc.internal.pageSize.getWidth();
      var pageHeight = doc.internal.pageSize.getHeight();
      var y = margin;

      if (logo && logo.dataUrl && logo.width && logo.height) {
        var maxLogoWidth = 120;
        var maxLogoHeight = 60;
        var ratio = Math.min(maxLogoWidth / logo.width, maxLogoHeight / logo.height, 1);
        var logoWidth = logo.width * ratio;
        var logoHeight = logo.height * ratio;
        try {
          doc.addImage(logo.dataUrl, 'PNG', margin, y, logoWidth, logoHeight);
          y += logoHeight + 16;
        } catch (e) {
          /* malformed image data - skip it, PDF still generates */
        }
      }

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      doc.text(pdfTitle, margin, y);
      y += 26;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      collectInputsSummary().forEach(function (line) {
        doc.text(line, margin, y);
        y += 14;
      });
      y += 12;

      collectScenarioCards().forEach(function (card) {
        if (y > pageHeight - 90) {
          doc.addPage();
          y = margin;
        }
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(13);
        doc.text(card.name, margin, y);
        y += 18;

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        card.rows.forEach(function (row) {
          if (y > pageHeight - 50) {
            doc.addPage();
            y = margin;
          }
          doc.text(row.label + ':', margin + 10, y);
          doc.text(row.value, margin + 230, y);
          y += 14;
        });
        y += 18;
      });

      // Disclaimer, wrapped to the page width, appended at the end so the
      // exported PDF carries the same legal text as the on-page section.
      if (disclaimerText) {
        if (y < pageHeight - 100) {
          y += 8;
        } else {
          doc.addPage();
          y = margin;
        }
        doc.setDrawColor(200, 200, 200);
        doc.line(margin, y, pageWidth - margin, y);
        y += 16;

        doc.setFont('helvetica', 'italic');
        doc.setFontSize(8);
        var wrapped = doc.splitTextToSize(disclaimerText, pageWidth - margin * 2);
        wrapped.forEach(function (line) {
          if (y > pageHeight - 40) {
            doc.addPage();
            y = margin;
          }
          doc.text(line, margin, y);
          y += 11;
        });
      }

      return doc.output('bloburl');
    }

    function handlePdfClick() {
      var newWindow = null;
      try {
        newWindow = window.open('', '_blank');
      } catch (e) {
        newWindow = null;
      }
      if (newWindow) {
        try {
          newWindow.document.title = pdfTitle;
          newWindow.document.body.style.cssText = 'font-family: sans-serif; padding: 40px; color: #333;';
          newWindow.document.body.textContent = pdfGeneratingLabel;
        } catch (e) {
          /* ignore - some browsers restrict writing to a blank popup */
        }
      }
      Promise.all([loadJsPDF(), loadLogoImage(pdfLogoUrl)]).then(function (results) {
        var JsPDFCtor = results[0];
        var logo = results[1];
        var blobUrl = buildPdf(JsPDFCtor, logo);
        if (newWindow && !newWindow.closed) {
          newWindow.location.href = blobUrl;
        } else {
          window.open(blobUrl, '_blank');
        }
      }).catch(function () {
        if (newWindow && !newWindow.closed) {
          try {
            newWindow.document.body.textContent = pdfErrorLabel;
          } catch (e) {
            /* ignore */
          }
        }
      });
    }

    function buildEmailBody() {
      var lines = [];
      if (emailIntroText) {
        lines.push(emailIntroText, '');
      }
      lines = lines.concat(collectInputsSummary());
      lines.push('');
      collectScenarioCards().forEach(function (card) {
        lines.push(card.name.toUpperCase());
        card.rows.forEach(function (row) {
          lines.push('  ' + row.label + ': ' + row.value);
        });
        lines.push('');
      });
      if (emailOutroText) {
        lines.push(fillTemplate(emailOutroText, { url: window.location.href }));
      }
      return lines.join('\n');
    }

    function handleEmailClick() {
      var body = buildEmailBody();
      var mailto = 'mailto:?subject=' + encodeURIComponent(emailSubject) + '&body=' + encodeURIComponent(body);
      window.location.href = mailto;
    }

    function bindSlider(slider) {
      slider.addEventListener('input', scheduleUpdate);
    }

    function bindNumber(numberInput, slider, min, max) {
      if (!numberInput) return;
      numberInput.addEventListener('change', function () {
        var value = clamp(numberInput, min, max);
        numberInput.value = value;
        slider.value = value;
        scheduleUpdate();
      });
    }

    bindSlider(priceSlider);
    bindSlider(rentalsSlider);
    bindSlider(monthsSlider);
    bindSlider(monthlyCostSlider);

    bindNumber(priceNumber, priceSlider, parseFloat(priceSlider.min), parseFloat(priceSlider.max));
    bindNumber(rentalsNumber, rentalsSlider, parseFloat(rentalsSlider.min), parseFloat(rentalsSlider.max));
    bindNumber(monthsNumber, monthsSlider, parseFloat(monthsSlider.min), parseFloat(monthsSlider.max));
    bindNumber(monthlyCostNumber, monthlyCostSlider, parseFloat(monthlyCostSlider.min), parseFloat(monthlyCostSlider.max));

    if (pdfButton) pdfButton.addEventListener('click', handlePdfClick);
    if (emailButton) emailButton.addEventListener('click', handleEmailClick);

    markInitialised(root);
    root.hidden = false;
    update();
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;

    var roots = context.querySelectorAll(SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      initSection(roots[i]);
    }
    if (context.matches && context.matches(SELECTOR)) {
      initSection(context);
    }

    var ctaLinks = context.querySelectorAll('[data-sauna-roi-cta]');
    for (var j = 0; j < ctaLinks.length; j++) {
      initCtaAnchor(ctaLinks[j]);
    }
    if (context.matches && context.matches('[data-sauna-roi-cta]')) {
      initCtaAnchor(context);
    }
  }

  function ready() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
